/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

/**
 * VerifyEmail Input Action
 */
export class VerifyEmailInput implements Msdyn365.IActionInput {
    public emailAddress: string;
    constructor(emailAddress: string) {
        this.emailAddress = emailAddress;
    }
    public getCacheKey = () => `DEFAULT + ${this.emailAddress} ${new Date()}`;
    public getCacheObjectType = () => `IVerifyEmailData  ${new Date()}`;
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

export interface IVerifyEmailData {
    response: boolean;
}

const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new VerifyEmailInput('');
};

async function action(input: VerifyEmailInput, ctx: Msdyn365.IActionContext): Promise<IVerifyEmailData> {
    let result: boolean = false;
    await Msdyn365.sendRequest(
        `${ctx.requestContext.apiSettings.baseUrl}Commerce/TecCreateEmailValidationCode`,
        'post',
        {
            createEmailValidationRequestModel: {
                EmailAddress: input.emailAddress,
                LanguageId: ctx.requestContext.locale
            }
        },
        { headers: { OUN: ctx.requestContext.apiSettings.oun } }
    ).then(res => {
        result = (res?.data as any)?.value;
    });

    // TODO: When Backend fixed error, remove
    if (!result) {
        return { response: true };
    }
    return { response: result };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IVerifyEmailData>>action,
    id: 'TecCreateEmailValidationCode',
    input: createInput
});
